<page-load-header *ngIf="!conference"></page-load-header>
<ng-container *ngIf="conference">
  <nav class="navbar navbar-expand-lg" [style]="'background-color: ' + conference.navBGColor + ' !important'" [ngClass]="{ 'navbar-light bg-light': conference.navLight, 'navbar-dark bg-dark': !conference.navLight }">
    <a class="navbar-brand" [routerLink]="['/']">
      <img *ngIf="conference.navLight" height="30" class="d-inline-block align-top" alt="" src="{{ settings.brand.logoPathLightBackground }}" />
      <img *ngIf="!conference.navLight" height="30" class="d-inline-block align-top" alt="" src="{{ settings.brand.logoPathDarkBackground }}"
    /></a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse branded-navbar" id="navbarNavDropdown">
      <ul class="navbar-nav mr-auto">
        <ng-container *ngFor="let page of pages">
          <li *ngIf="!page.hidden" class="nav-item" [routerLinkActive]="['active']" [ngStyle]="{ 'border-bottom-color': conference.navActiveColor }">
            <a *ngIf="!page.isExternalLink" class="nav-link"  [ngStyle]="{ 'color': conference.navTextColor}" [routerLink]="[page.slug]">{{ page.navText | translate }} <span class="sr-only">(current)</span></a>
            <a *ngIf="page.isExternalLink" class="nav-link"  [ngStyle]="{ 'color': conference.navTextColor}" target="_blank" href="{{ page.externalLink }}">{{ page.navText | translate }} <span class="sr-only">(current)</span></a>
          </li>
        </ng-container>
      </ul>

      <ul *ngIf="auth.isLoggedIn() && auth.user" class="navbar-nav my-2 my-lg-0">
        <li class="nav-item">
          <a class="nav-link" style="position: relative" [routerLink]="['cart']">
            <i class="fas fa-shopping-cart"></i>
            <span *ngIf="cart.totalItems > 0" class="badge badge-sm badge-primary badge-pos rounded-circle" style="top: 5px">{{ cart.totalItems }}</span>
          </a>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"> {{ auth.user.firstName }} {{ auth.user.lastName }} </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">
            <a class="dropdown-item" [routerLink]="['/account/profile']"> {{ 'My Account' | translate }} </a>
            <a class="dropdown-item" [routerLink]="['/account/ceus']"> {{ 'CEU History' | translate }}</a>
            <a class="dropdown-item" [routerLink]="['my-events']">{{ 'My Live Presentations' | translate }}</a>
            <a *ngIf="conference.showPosters" class="dropdown-item" [routerLink]="['my-posters']">My Posters</a>
            <a *ngIf="conference.showPosters" class="dropdown-item" [routerLink]="['call-for-posters']">Call for Posters</a>
            <div *ngIf="auth && auth.isSuperUser()" class="dropdown-divider"></div>
            <a *ngIf="auth && auth.isSuperUser()" class="dropdown-item" [routerLink]="['/super-user']">Super User</a>
            <a *ngIf="(auth && auth.isSuperUser()) || isCompanyAdmin" class="dropdown-item" [routerLink]="['/organizations', organization.slug, 'admin']">Admin Page</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" [routerLink]="[]" (click)="logout()">{{ 'log-out' | translate }}</a>
          </div>
        </li>
      </ul>
      <ul *ngIf="!auth.isLoggedIn()" class="navbar-nav my-2 my-lg-0">
        <li class="nav-item">
          <button class="btn btn-sm btn-primary" (click)="nav.showLogin()">Login / Sign Up</button>
        </li>
      </ul>
    </div>
  </nav>

  <div *ngIf="!conference.homePageHeroBGAsset || !conference.homePageHeroFGAsset" [innerHTML]="conference.navBannerHtml | safeHtml"></div>
  <div *ngIf="conference.homePageHeroBGAsset && conference.homePageHeroFGAsset">
    <div class="vbc-background bg-cover" [style]="'padding-top:' + conference.navHeroPadding + '; padding-bottom: ' + conference.navHeroPadding + '; background-position: center; background-size: cover;background-image: url(/fetchImage?filename=' + conference.homePageHeroBGAsset + ')'">
      <div class="container vbc-container">
        <div class="flex align-center mb-70 row wrap-md text-center-md">
          <div class="col-md-12 col-xs-12 mb-md-20 text-center"><img src="/fetchImage?filename={{ conference.homePageHeroFGAsset }}" alt="logo" class="img-fluid" style="margin-left: auto; margin-right: auto" /></div>
        </div>
      </div>
    </div>
  </div>
  <main id="content" role="main">
    <div class="position-relative z-index-2">
      <router-outlet></router-outlet>
    </div>
  </main>
</ng-container>
